module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Locked-folder-b7191643603e28f8418a65ef0560a436.svg";